import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about-container" }
const _hoisted_2 = { class: "bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationTab = _resolveComponent("NavigationTab")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.TabbedbarFeatureFlagValue ? 'NavigationTabbedBar' : 'NavigationTabToolbar'), null, {
      "main-group": _withCtx(() => [
        _createVNode(_component_NavigationTab, {
          route: _ctx.routeNames.AboutSystemInformationRoute,
          icon: "/icons/about/system_info_icon.svg",
          title: _ctx.TabbedbarFeatureFlagValue ? '' : _ctx.localizer.Localize('About_System_Information'),
          tabName: _ctx.TabbedbarFeatureFlagValue ? _ctx.localizer.Localize('About_System_Information') : null
        }, null, 8, ["route", "title", "tabName"])
      ]),
      _: 1
    }, 512)), [
      [_vShow, _ctx.TabbedbarFeatureFlagValue !== null]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}